import { APIClient } from "../../helpers/api_helper";

const api = new APIClient();

const CREATE_ADMIN_ENDPOINT = "/api/v1/auth/admin/create";

export interface CreateAdminRequest {
  fullName: string;
  email: string;
  password: string;
  countryCode?: number;
  phoneNumber?: number;
  role_code: string;
  scope_type?: string;
  scope_ids?: string[];
  created_by?: string;
}

export interface CreateAdminResponse {
  message?: string;
  data?: unknown;
  [key: string]: unknown;
}

/**
 * Create an admin user.
 * POST /api/v1/auth/admin/create
 */
export const createAdmin = async (
  payload: CreateAdminRequest
): Promise<CreateAdminResponse> => {
  const response = await api.create(CREATE_ADMIN_ENDPOINT, payload);
  return response as unknown as CreateAdminResponse;
};
